import { CardForm, InputDateForm, InputNumberForm, InputTextForm } from '@/uiComponents/common';
import SelectForm from '@/uiComponents/common/selects/selectNew';

const IdentificationCard = ({ t, className, documentTypes, gender }) => {
  return (
    <>
      <CardForm
        title={t('identificationCard.title')}
        className={className}
      >
        <div className='row tw-mb-6'>
          <InputDateForm
            name={'dateOfBirth'}
            label={t('rowIdentification.inputDate.label')}
            placeholder={t('rowIdentification.inputDate.placeholder')}
            className={'col-6 tw-mb-6'}
            captionLayout='dropdown'
          />
          <InputTextForm
            name={'nationality'}
            label={t('rowIdentification.inputNationality.label')}
            placeholder={t('rowIdentification.inputNationality.placeholder')}
            maxLength={510}
            className={'col-6 tw-mb-6'}
          />

          <SelectForm
            name={'documentType'}
            options={documentTypes}
            label={t('rowIdentification.inputTypeDocument.label')}
            placeholder={t('rowIdentification.inputTypeDocument.placeholder')}
            maxLength={510}
            className={'col-6 tw-mb-6'}
          />
          <InputNumberForm
            name={'documentNumber'}
            label={t('rowIdentification.inputNumberDocument.label')}
            placeholder={t('rowIdentification.inputNumberDocument.placeholder')}
            maxLength={510}
            className={'col-6 tw-mb-6'}
          />
          <SelectForm
            name={'gender'}
            options={gender}
            label={t('rowIdentification.inputGender.label')}
            placeholder={t('rowIdentification.inputGender.placeholder')}
            maxLength={510}
            className={'col-6 tw-mb-6'}
          />
        </div>
      </CardForm>
    </>
  );
};

export default IdentificationCard;
